import React, { useState, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import './AuditList.css'
import share from "./share.png";
import { useNavigate, useLocation } from 'react-router-dom'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Support from '../contact-popup-module/Support'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import CircularProgress from '@material-ui/core/CircularProgress'
import moment from 'moment'
import ShareAuditOptions from '../audit-creation-module/inspection-mode/ShareAuditOptions'
import { useSwipeable } from 'react-swipeable'
import { saveAs } from 'file-saver'

function Claim({ userID: propUserID, activeTab: propActiveTab, onCountUpdate }) {
  //  const swipeHandlers = useSwipeable({
  //      onSwiping: () => setSwiping(true),
  //      onSwiped: () => setSwiping(false),
  //      // onSwipedLeft: () => {
  //      //   // Disable swipe to claim tab
  //      //   const currentIndex = tabs.indexOf(activeTab)
  //      //   if (currentIndex < tabs.length - 1 && tabs[currentIndex + 1] !== 'claim') {
  //      //     handleTabClick(tabs[currentIndex + 1])
  //      //   }
  //      // },
  //      onSwipedLeft: () => {
  //    const currentIndex = tabs.indexOf(activeTab);
  //    if (currentIndex < tabs.length - 1 && tabs[currentIndex + 1] !== 'inactive') {
  //      handleTabClick(tabs[currentIndex + 1]);
  //          }
  //        },
   
  //      onSwipedRight: () => {
  //        const currentIndex = tabs.indexOf(activeTab)
  //        if (currentIndex > 0) {
  //          handleTabClick(tabs[currentIndex - 1])
  //        }
  //      },
  //      delta: 80,
  //      trackTouch: true,
  //      preventScrollOnSwipe: true
  //    })
 const downloadIcon = `${process.env.PUBLIC_URL}/custom-icons/download.svg`
  const calendar = `${process.env.PUBLIC_URL}/custom-icons/calendar.png`
  const menuIcon = `${process.env.PUBLIC_URL}/custom-icons/menu-icon.png`
  const infoIcon = `${process.env.PUBLIC_URL}/custom-icons/info-icon.png`
  const copy = `${process.env.PUBLIC_URL}/custom-icons/pink-copy-icon.png`
  const searchIcon = `${process.env.PUBLIC_URL}/custom-icons/search.svg`
  const next = `${process.env.PUBLIC_URL}/custom-icons/next-arrow.png`
  const upArrow = `${process.env.PUBLIC_URL}/custom-icons/upArrow.svg`
  const downArrow = `${process.env.PUBLIC_URL}/custom-icons/downArrow.svg`

  const location = useLocation()
  const insuranceUser = JSON.parse(localStorage.getItem('insuranceUser'))
  const locationUserID = location.state ? location.state.userId : null
  const userID = propUserID || locationUserID || insuranceUser?.userId
  const [activeTab, setActiveTab] = useState(propActiveTab || location.state?.activeTab || 'new')
  const [currentFilter, setCurrentFilter] = useState('all')
  const [isPopupVisible, setIsPopupVisible] = useState(false)
  const popupRef = useRef(null)
  const navigate = useNavigate()
  const [audits, setAudits] = useState([])
  const [agentDetails, setAgentDetails] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [open, setOpen] = useState(false)
  const [openSharePopup, setOpenSharePopup] = useState(false)
  const [selectedAuditUrl, setSelectedAuditUrl] = useState('')
  const [dialogWidth, setDialogWidth] = useState('29vw')
const [groupView, setGroupView] = useState(true)
const [selectedGroup, setSelectedGroup] = useState(null)
  const [isAscending, setIsAscending] = useState(false)
  const tabs = ['new', 'renewal', 'claim']
  const [swiping, setSwiping] = useState(false)
  const [sortOrder, setSortOrder] = useState('desc')
// Earlier we were hiding the Start button when status was
// 'processed', 'processing', or 'expired'. This logic is now
// commented out so that the Start button always shows.
//
// const shouldShowButton = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   const hiddenStatuses = ['processed', 'processing', 'expired'];
//   return !hiddenStatuses.includes(status);
// };
// const shouldShowButton = (audit) => {
//   const status = audit.originalUsedStatus || audit.used;
//   const hiddenStatuses = ['processed', 'processing', 'expired'];
//   return !hiddenStatuses.includes(status);
// };
  const formatDateTime = (date, time) => {
    // 1) Combined date+time (expected formats and ISO)
    const dt = moment(`${date} ${time}`, ['DD-MM-YYYY HH:mm', moment.ISO_8601], true);
    if (dt.isValid()) {
      return { date: dt.format('DD-MM-YYYY'), time: dt.format('HH:mm') };
    }

    // 2) Date as ISO containing time
    const iso = moment(date, moment.ISO_8601, true);
    if (iso.isValid()) {
      return { date: iso.format('DD-MM-YYYY'), time: iso.format('HH:mm') };
    }

    // 3) Fallback to loose date parsing and pass through time if present
    const fallback = moment(date, ['DD-MM-YYYY'], true);
    return {
      date: fallback.isValid() ? fallback.format('DD-MM-YYYY') : date || '--',
      time: time || '--'
    };
  };
  const [audit_status, setAuditStatus] = useState(null)
  const [formDetailsMap, setFormDetailsMap] = useState({})
  const [allInfoLoaded, setAllInfoLoaded] = useState(false)
  const [loadingComplete, setLoadingComplete] = useState(false)
  const [counts, setCounts] = useState({ new: 0, inProgress: 0, inactive: 0 })
  const [sortedAudits, setSortedAudits] = useState([])
   useEffect(() => {
    const fetchAuditsAndDetails = async () => {
      setLoading(true);

      try {
        if (!userID) {
          console.error('User ID is missing');
          setLoading(false);
          return;
        }

        const [auditResponse, agentResponse] = await Promise.all([
          axios.post('/agentApis/getAgentAllAuditInfo2', { userID }),
          axios.post('/agentApis/getCompleteAgentInfo2', { userID })
        ]);

        console.log('Audits by user:', auditResponse.data, agentResponse.data);
        console.log('Audit response data type:', typeof auditResponse.data, 'Is array:', Array.isArray(auditResponse.data));
        console.log('Audit response data length:', Array.isArray(auditResponse.data) ? auditResponse.data.length : 'Not an array');

        // Ensure auditResponse.data is an array
        const rawAuditData = Array.isArray(auditResponse.data) 
          ? auditResponse.data 
          : (auditResponse.data && Array.isArray(auditResponse.data[0]) 
              ? auditResponse.data[0] 
              : []);

        console.log('Raw audit data length:', rawAuditData.length);
        console.log('Sample raw audit data:', rawAuditData.slice(0, 3));

        // Map initial audit data - ALL audits go to 'new' status (Endorsements)
        // Filter out records with null/undefined audit field but log them
        let auditData = rawAuditData
          .filter(item => {
            if (!item.audit) {
              console.warn('Found claim record without audit field:', item);
              return false;
            }
            return true;
          })
          .filter(item => item.used !== "expired")
          .map(item => {
            const leadTime = item.lead_creation_time || '';
            const [date = '--', time = '--'] = leadTime.split(' ');

            return {
              id: item.audit,
              date,
              time,
              used: item.used,
              status: 'new', // All audits are now shown in Endorsements tab
              type: ['Inspection'],
              mode: item.audit_mode,
              originalUsedStatus: item.used 
            };
          });

        console.log("Initial auditData length after filtering:", auditData.length);

        // Batch fetch audit details
        const auditIds = auditData.map(audit => audit.id);
        console.log("Total audits to fetch details for:", auditIds.length);

        const startTime = performance.now();

        const detailsResponse = await axios.post('/process_data/batch_check_and_get_details2', {
          auditIds
        });

        const endTime = performance.now();
        console.log(`Time taken to fetch batch details: ${(endTime - startTime).toFixed(2)} ms`);

        const fetchedDetails = detailsResponse.data.audits;

        // Merge fetched details with auditData
        const auditDataWithDetails = auditData.map(audit => {
          const found = fetchedDetails.find(item => item.id === audit.id);
          return {
            ...audit,
            Make: found?.details.Make || '',
            Model: found?.details.Model || '',
            'Name of Customer': found?.details["farmer_name"] || ' ',
            'Address': found?.details["Farmer's Address"] || ' '
          };
        });

        console.log("auditDataWithDetails:", auditDataWithDetails);

        // Compute status counts - all audits in 'new' status
        const computedCounts = {
          new: auditDataWithDetails.length,
          inProgress: 0,
          inactive: 0
        };

        console.log("Computed counts:", computedCounts);

        // Update state
        setAudits(auditDataWithDetails);
        setCounts(computedCounts);
        
        // Notify parent component of the claim count
        if (onCountUpdate) {
          onCountUpdate(auditDataWithDetails.length);
        }

        if (agentResponse.status === 200) {
          setAgentDetails(agentResponse.data[0]);
        } else {
          setError('Failed to fetch agent details');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('An error occurred while fetching data');
      } finally {
        setLoadingComplete(true);
        setLoading(false);
      }
    };

    fetchAuditsAndDetails();
  }, [userID]);

  const tabsRef = useRef({})

  const handleTabClick = tab => {
    // Only allow clicking on 'new' tab, disable 'inactive' tab
    if (tab === 'inactive') return;
    
    setActiveTab(tab)

    tabsRef.current[tab]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center'
    })
  }
  useEffect(() => {
    const handleResize = () => {
      const windowWidth = window.innerWidth
      if (windowWidth <= 450) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 475) {
        setDialogWidth('94vw')
      } else if (windowWidth <= 570) {
      } else if (windowWidth <= 575) {
        setDialogWidth('64vw')
      } else if (windowWidth <= 650) {
        setDialogWidth('60vw')
      } else if (windowWidth <= 700) {
      } else if (window.innerWidth <= 775) {
        setDialogWidth('57vw')
      } else if (window.innerWidth <= 875) {
        setDialogWidth('55vw')
      } else if (windowWidth <= 1000) {
        setDialogWidth('48vw')
      } else if (window.innerWidth <= 1100) {
        setDialogWidth('45vw')
      } else if (windowWidth <= 1300) {
        setDialogWidth('40vw')
      } else {
        setDialogWidth('35vw')
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize()
    return () => window.removeEventListener('resize', handleResize)
  }, [])
   
  // const handleNavigateClick = audit => {
  //   console.log(userID)
  //   navigate(`/auditDescription2`, {
  //     state: { audit, userID, agentDetails, activeTab }
  //   })
  // }
  const handleNavigateClick = (audit) => {
  if (audit.used === "processed") {
    navigate(`/AuditDeathDesc/${audit.id}`, 
      { state: { audit, userID, agentDetails, activeTab: "claim" } });
  } else {
    navigate(`/auditDescription2`, { state: { audit, userID, agentDetails, activeTab: "claim" } });
  }
};
  const [filteredAudit, setFilteredAudit] = useState([])
  console.log('Claim props -> userID:', userID, 'activeTab:', activeTab)

  // Show all audits (or the searched subset) in the Claim tab.
  // Earlier we were filtering by `audit.status === activeTab` but all audits
  // are mapped with status 'new', so nothing matched when activeTab was 'claim',
  // resulting in a blank screen.
  const filteredAudits = filteredAudit.length > 0 ? filteredAudit : audits

const groupedAudits = filteredAudits.reduce((acc, audit) => {
  const baseId = audit.id.split('_')[0]

  if (!acc[baseId]) {
    acc[baseId] = []
  }

  acc[baseId].push(audit)

  return acc
}, {})
const handleGroupClick = (groupId) => {
  setSelectedGroup(groupId)
  setGroupView(false)
}
const handleBackToGroups = () => {
  setGroupView(true)
  setSelectedGroup(null)
}
  // Local search handler for Claim tab so that the search bar
  // appears above the claim results and filters this list only.
  const handleSearch = query => {
    const q = (query || '').toLowerCase()
    const filtered = audits.filter(audit =>
      (audit['Name of Customer'] || '').toLowerCase().includes(q) ||
      (audit.id || '').toLowerCase().includes(q)
    )
    setFilteredAudit(filtered)
  }
  const getButtonLabel = (audit) => (audit.used === "processed" ? "More Info" : "Start");

  return (
    <div className='audit-list-container'>
      {/* Search bar for Claim tab – shown above the auditsResponse cards */}
      <div className='filters'>
        <div className='search-container'>
          <input
            type='text'
            placeholder='Search'
            className='search-input'
            onChange={e => handleSearch(e.target.value)}
          />
          <img src={searchIcon} alt='Search Icon' className='search-icon' />
        </div>
      </div>

      {!loadingComplete ? (
        <div className='loader-container'>
          <CircularProgress style={{ color: '#FC350B' }} size={40} />
          <p className='loading-text'>Loading audits...</p>
        </div>
      ) : audits.length === 0 ? (
        <div className='no-audit-message'>
          <p>No audits found.</p>
        </div>
      ) : (
        <div
          // {...swipeHandlers}
          className={`audit-cards ${swiping ? 'swiping' : ''}`}
        >
                 {
  groupView ? (

    Object.keys(groupedAudits).map(groupId => (
      <div
        className="audit-card"
        key={groupId}
        style={{ cursor: "pointer" }}
        onClick={() => handleGroupClick(groupId)}
      >
        <div className="audit-header">
          <div className="header-one">
            <p className="audit-id">{groupId}</p>
          </div>

          <div className="header-two">
            <p>{groupedAudits[groupId].length} Claims</p>
          </div>
        </div>
      </div>
    ))

  ) : (

    <>
      {/* <button
        onClick={handleBackToGroups}
        style={{ marginBottom: "10px", cursor: "pointer",float:"left" }}
      >
        ← Back
      </button> */}
<div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "10px" }}>
  <button
    onClick={handleBackToGroups}
    style={{ cursor: "pointer" }}
  >
    ← Back to Groups
  </button>
</div>
      {
        groupedAudits[selectedGroup]
          .slice()
          .sort((a, b) => {

            const dateA = moment(
              `${a.date} ${a.time}`,
              'DD-MM-YYYY HH:mm'
            ).toDate()

            const dateB = moment(
              `${b.date} ${b.time}`,
              'DD-MM-YYYY HH:mm'
            ).toDate()

            return sortOrder === 'asc' ? dateA - dateB : dateB - dateA
          })
          .map(audit => {

            console.log('Claim audit status ->', {
              id: audit.id,
              used: audit.used,
              originalUsedStatus: audit.originalUsedStatus
            })

            const formatted = formatDateTime(audit.date, audit.time);

            return (
              <div className='audit-card' key={audit.id}>

                <div className='audit-header'>
                  <div className='header-one'>
                    <p className='audit-id'>{audit.id}</p>

                    <div className='date-container'>
                      <img
                        src={calendar}
                        alt='Calendar Icon'
                        className='calendar-icon'
                      />
                      <p>{formatted.date}</p>
                    </div>
                  </div>

                  <div className='header-two'>
                    <div className='audit-tags'>
                      {audit.mode && (
                        <span className='audit-tag'>
                          {audit.mode.charAt(0).toUpperCase() +
                            audit.mode.slice(1).toLowerCase()} Mode
                        </span>
                      )}
                    </div>

                    <p>{formatted.time}</p>
                  </div>
                </div>

                <div className='audit-details'>
                  <p>
                    Name: {audit['Name of Customer'] || ''}
                  </p>

                  <p>
                    Address : {audit['Address'] || ''}
                  </p>
                </div>

                <div className='audit-actions'>
                  <button
                    className='navigate-button'
                    onClick={() => handleNavigateClick(audit)}
                  >
                    {getButtonLabel(audit)}
                    <img src={next} alt='next Icon' className='next-icon' />
                  </button>
                </div>

              </div>
            )
          })
      }
    </>
  )
}
                </div>
              )}</div>
  )
}

export default Claim
